import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export default {
  namespaced: true,
  state: {
    appID: -1,
    appListingStatus: -1,
    isEditMode: false,
    appType: '',
    stepsCompletedList: [],
    isPrivateApp: false,
  },
  mutations,
  actions,
  getters,
};
